<template>
  <div id="app">
    <!-- サインイン済みの場合ヘッダーを表示 -->
    <Header v-if="getSignin" />
    <!-- メイン画面 -->
    <router-view/>
    <br>
    <!-- フッター（言語設定） -->
    <div id="lang">
      <li><a href="#" v-on:click.prevent="changeLanguage('en')">English</a></li> | 
      <li><a href="#" v-on:click.prevent="changeLanguage('ja')">日本語</a></li>
    </div>
    <!-- プライバシーポリシー -->
<!-- 
    <div id="privacy">
    <table>
    <thead>
      <tr>
        <th><a v-on:click="externalLink">{{ $t("Common.PrivacyPolicy") }}</a></th>
      </tr>
    </thead>
    </table>
    </div>
-->
  </div>
</template>

<script>
// header.vueをインポート
import Header from "./components/header";
import CONST from './const/const.js'  // 定数
import base64url from "base64url";    // payloadのデコード

export default {
  name: 'app',
  data () {
    return {
      code : '',
      dev : '',
    }
  },

  /*
   * components: 子コンポーネント
   */
  components: {
    Header,
  },

  /*
   * created: 初期処理
   */
  created : function(){
console.log('App - created');
console.log('signin : ' + sessionStorage.getItem("signin"));
    if(sessionStorage.getItem("signin") !== null) {
      // サインイン済みの場合は認証処理を行わない
      this.$router.push({ path: '/search', name: 'Search' });
    } else {
      // クエリパラメータの取得（ATSC認証の場合は[code]パラメータが付与される）
      const urlParams = new URLSearchParams(window.location.search);
      this.code = urlParams.get("code");
      this.dev = urlParams.get("dev");
//console.log(this.code);
//console.log(this.dev);

      if (this.dev && this.dev === 'true') {
        // 開発者ユーザ（Cognito認証）
console.log('開発者ユーザ');
        // サインイン画面へ遷移
        this.$router.push({ path: '/signin', name: 'Signin', params: {no: 0} })
      } else if(this.code) {
        // 販売店ユーザ（ATSC認証経由）
console.log('販売店ユーザ');
        const CognitoAppClientID = this.$cognito.userPool.clientId;
        const localStorageMainKey = "CognitoIdentityServiceProvider." + CognitoAppClientID;
        if (this.code) {
          // パラメータの設定
          const params = new URLSearchParams();
          params.append("grant_type", "authorization_code");
          params.append("redirect_uri", process.env.VUE_APP_REDIRECT_URL);
          params.append("code", this.code);
          params.append("client_id", CognitoAppClientID);

          // Tokenの取得
          const CognitoBaseURL = process.env.VUE_APP_BASE_URL;
          this.$axios.post(CognitoBaseURL + "/oauth2/token", params, {
            headers : {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((token) => {
//console.log('token');
//console.log(token);

            // グループ取得
            const payload = token.data.id_token.split(".");
            const decodIdToken = JSON.parse(base64url.decode(payload[1]));
            var group = '';
            if ('cognito:groups' in decodIdToken) {
              // グループ設定有（ATSC認証は自動付与される/開発者ユーザーの場合は手動で設定）
              group = decodIdToken['cognito:groups'][0];
            } else {
              // 開発者ユーザーのグループ設定漏れ
            }

            // 「developer」グループ所属は開発者ユーザ
            if(group === CONST.USER_KBN.DEVELOP) {
              // サインイン画面へ遷移
              this.$router.push({ path: '/signin', name: 'Signin', params: {no: 0} })
            } else if (group === '') {
              // サインイン画面へ遷移（設定漏れエラー）
              this.$router.push({ path: '/signin', name: 'Signin', params: {no: 1} })
            } else {
              const bearer = "Bearer " + token.data.access_token;
              // ユーザー情報の取得
              this.$axios.post(CognitoBaseURL + "/oauth2/userInfo", {}, {
                headers : {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "Authorization": bearer
                }
              }).then((userInfo) => {
//console.log('userInfo');
//console.log(userInfo);

                // IDトークンによるアクセス認可用ヘッダーを生成
                var header = {
                  headers: {
                    "Authorization": token.data.id_token
                  }
                }
                // KITORAユーザー権限チェック
                this.$axios.post(process.env.VUE_APP_REDIRECT_URL + "errorreport/auth", {}, header).then(response => {
console.log(response.data.statusCode);
                  // 正常終了
                  if (response.data.statusCode === 200) {

                    // localStorageを書き換え
                    const localStorageSubKey = localStorageMainKey + "." + userInfo.data.sub;
                    localStorage.setItem(localStorageSubKey + ".accessToken", token.data.access_token);
                    localStorage.setItem(localStorageSubKey + ".idToken", token.data.id_token);
                    localStorage.setItem(localStorageSubKey + ".refreshToken", token.data.refresh_token);
                    localStorage.setItem(localStorageSubKey + ".clockDrift", "0");
                    localStorage.setItem(localStorageMainKey + ".LastAuthUser", userInfo.data.sub);
                    sessionStorage.setItem('signin', '1');

                    // Cognito認証
                    this.$cognito.isAuthenticated().then(session => {// eslint-disable-line
console.log('App - 検索画面へ遷移');
                      // 検索画面へ遷移
                      this.$router.push({ path: '/search', name: 'Search' });
                    })
                    // Cognitoの認証エラーの場合
                    .catch(error => { // eslint-disable-line
console.log('App - Cognitoの認証エラー');
                      console.log(error);
                      this.$router.push({ path: '/kitora', name: 'Kitora', params: {no: 403}});
                    });// 

                  // 500 or 403系エラー
                  } else {
                    this.$router.push({ path: '/kitora', name: 'Kitora', params: {no: response.data.statusCode}});
                  }

                }).catch((err) => {
console.log('App - post エラー KITORAユーザー権限チェック');
                  console.error(err);
                  this.$router.push({ path: '/kitora', name: 'Kitora', params: {no: 500}});
                });// KITORAユーザー権限チェック

              }).catch((err) => {
console.log('App - post エラー ユーザー情報の取得');
                console.error(err);
                this.$router.push({ path: '/', name: 'Index' });
              });// ユーザー情報の取得
            }// 開発者ユーザ/販売会社ユーザ判定

          }).catch((err) => {
console.log('App - post エラー2 Tokenの取得');
            console.error(err);
            this.$router.push({ path: '/', name: 'Index' });
          });// Tokenの取得
        }
      } else {
console.log('KITORA認証ボタン画面');
        this.$router.push({ path: '/kitora', name: 'Kitora', params: {no: 0}});
      }
    }
  },

  /*
   * methods: メソッド
   */
  methods: {
    // 言語切替
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    confirmSave (event) {// eslint-disable-line
      //event.returnValue = "編集中のものは保存されませんが、よろしいですか？";
      // 別サイトに画面遷移、又はリロードするとサインアウトしてしまう
      //this.$router.push('/signout');
    },

    // 外部サイトへ別タブで開く
    externalLink() {
      const url = this.$t("Common.PrivacyPolicyLink")
      window.open(url, '_blank');
    }
  },

  /*
   * mounted: elementへのマウント
   */
  mounted () {
    window.addEventListener("beforeunload", this.confirmSave);
  },

  /*
   * beforeDestroy: Vue インスタンスが破壊される前
   */
  beforeDestroy () {
    window.removeEventListener("beforeunload", this.confirmSave);
  },

  /*
   * computed: 算出プロパティ
   */
  computed: {
    // サインイン済みを判定
    getSignin: function() {
      if (this.$store.state.user) {
        return true;
      }

      return false;
    },
  },
}
</script>

<style lang="scss">
/* 全体共通CSSの読込 */
@import "./css/styles.css";

/*--------------------
   BASIC CLASSES
--------------------*/
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 0px;
  line-height: 20px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#lang {
  li {
    display: inline;
  }
  a {
    font-weight: bold;
    color: #2c3e50;
  }
  li.selected  {
    color: #42b983;
  }
}

#privacy {
  max-width: 640px;
  margin: 0 auto;

  a:hover  {
    color:#C0C0C0;
    cursor: pointer;
  }
}
</style>
